<template>
  <div class="lingyang">
    <el-dialog :visible.sync="dialogFormVisible" @close="down()" width="85%">
      <div class="box">
        <div class="box_left">
          <el-input
            placeholder="请输入内容"
            v-model="query.keyword"
            class="input-with-select"
          >
            <el-button slot="append" icon="el-icon-search" @click="getProductList()"></el-button>
          </el-input>
          <div>
            <div>
              <div
                class="box_left_daren"
                @click="one_intelligent(item, index)"
                v-for="(item, index) in restaurants"
                :class="xzindex[index] == true ? 'showimg' : 'displayimg'"
                :key="item.id"
              >
                <img :src="item.avatar" alt="" />
                <span>{{ item.nickname }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="box_right">
          <div class="box_right_title_table">
            <div class="box_right_title">
              <img src="../../assets/images/douyin.png" alt="" srcset="" />
              <span>{{ listproduct.title }}</span>
            </div>
            <el-table :data="tableData" style="width: 100%">
              <el-table-column prop="forminput2.avatar" label="达人" width="70">
                <template slot-scope="scope">
                  <img class="table_img" :src="scope.row.avatar" />
                </template>
              </el-table-column>
              <el-table-column prop="gui" label="规格">
                <template slot-scope="scope">
                  <el-select
                    style="width: 100%"
                    v-model="scope.row.guige"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, index) in scope.row.sku"
                      :key="index"
                      :label="item.name"
                      :value="item.name"
                    >
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="forminput2.fenshu" label="份数">
                <template slot-scope="scope">
                  <el-select
                    v-model="scope.row.fenshu"
                    style="width: 100%"
                    placeholder="请选择"
                  >
                    <el-option label="1份" value="1"> </el-option>
                    <el-option label="2份" value="2"> </el-option>
                    <el-option label="3份" value="3"> </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="address" label="产品名称">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.product_name"></el-input
                ></template>
              </el-table-column>
              <el-table-column prop="forminput2.post_address" label="收获地址">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.post_address"></el-input
                ></template>
              </el-table-column>
              <el-table-column
                prop="forminput2.post_telephone"
                label="收获电话"
              >
                <template slot-scope="scope">
                  <el-input v-model="scope.row.post_telephone"></el-input
                ></template>
              </el-table-column>
              <el-table-column prop="forminput2.colonel" label="团长名称">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.colonel"></el-input
                ></template>
              </el-table-column>
              <el-table-column prop="address" label="收货名字">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.post_name"></el-input
                ></template>
              </el-table-column>
            </el-table>
          </div>
          <div class="footer_btn">
            <el-button type="primary" @click="deltable()">一键清空</el-button>
            <el-button @click="open">免费领取</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  Add,
  Getlist,
  Update,
  Epress,
  Del,
  myExperts,
  BatchAdd,
} from '@/api/api2'
export default {
  props: ['listproduct'],
  data() {
    var validatorPhone = function (rule, value, callback) {
      if (value === '') {
        callback(new Error('手机号不能为空'))
      } else if (!/^1\d{10}$/.test(value)) {
        callback(new Error('手机号格式错误'))
      } else {
        callback()
      }
    }

    var validatorFenshu = function (rule, value, callback) {
      if (value != '') {
        if (/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/.test(value) == false) {
          callback(new Error('请填写大于0的数字'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      colonel: '',
      tableData: [],
      xzindex: [],
      show: true,
      loginformrules: {
        colonel: [
          { required: true, message: '请输入相关内容', trigger: 'blur' },
        ],
        post_telephone: [
          { required: true, validator: validatorPhone, trigger: 'blur' },
        ],
        fenshu: [
          {
            required: true,
            validator: validatorFenshu,
            trigger: 'change',
          },
        ],
      },
      query: {
        input: '',
        keyword:'',
      },
      formLabelWidth: '120px',
      forminput: {
        experts_id: '',
        product_id: '',
        experts: '',
        product_name: '',
        guige: '',
        fenshu: '1',
        post_name: '',
        post_telephone: '',
        post_address: '',
        colonel: '',
        express: '',
      },
      restaurants: [],
      dialogFormVisible: false,
    }
  },
  methods: {
    deltable() {
      this.xzindex = []
      if (this.restaurants.length != 0) {
        this.restaurants.forEach((element) => {
          this.xzindex.push(false)
        })
      }
      this.tableData = []
    },
    down() {
      this.restaurants = []
      ;(this.tableData = []), (this.xzindex = [])
      console.log(this.xzindex)
    },
    // 获取table数据
    open() {
      let params = new URLSearchParams()
      params.append('info', JSON.stringify(this.tableData))
      params.append('product_id', this.listproduct.id)
      BatchAdd(params)
        .then((res) => {
          console.log(res)
          this.dialogFormVisible = false
          this.$message.success('添加成功')
          this.restaurants = []
        })
        .catch((err) => {})
    },
    // 第一次点击添加
    one_intelligent(item, index) {
      item.sku = this.listproduct.sku
      this.xzindex.splice(index, 1, !this.xzindex[index])
      if (this.xzindex[index]) {
        this.tableData.push(item)
      } else {
        let arr = []
        this.tableData.forEach((element, index) => {
          console.log(index)
          if (element != item) {
            arr.push(element)
          }
          this.tableData = arr
        })
      }
    },
    guanbi() {
      this.$refs.forminput2.resetFields()
    },
        // 1. 先获取数据
    // getProductList2() {
    //   let params = new URLSearchParams()
    //   params.append("keyword",this.query.keyword)
    //   myExperts(params).then((res) => {
    //     if (res.data.length != 0) {
    //       res.data.map((item, index) => {
    //         delete item.id
    //         item.colonel = this.listproduct.channels_name
    //         item.express = this.listproduct.express
    //         item.product_name = this.listproduct.title
    //         this.restaurants.push(
    //           Object.assign(item, { guige: '', fenshu: '' })
    //         )
    //       })
    //       console.log(this.restaurants)
    //       if (this.restaurants.length != 0) {
    //         this.restaurants.forEach((element) => {
    //           this.xzindex.push(false)
    //         })
    //       }
    //       console.log(this.xzindex)
    //     }
    //   })
    // },
    // 1. 先获取数据
    getProductList() {
      this.tableData=[]
      this.restaurants =[]
      let params = new URLSearchParams()
       params.append("keyword",this.query.keyword)
      myExperts(params).then((res) => {
        if (res.data.length != 0) {
          res.data.map((item, index) => {
            delete item.id
            item.colonel = this.listproduct.channels_name
            item.express = this.listproduct.express
            item.product_name = this.listproduct.title
            this.restaurants.push(
              Object.assign(item, { guige: '', fenshu: '' })
            )
          })
          if (this.restaurants.length != 0) {
            this.restaurants.forEach((element) => {
              this.xzindex.push(false)
            })
          }

        }
      })
    },
    openbox() {
      this.getProductList()
      this.dialogFormVisible = true
    },
    // // 2. 模糊搜索，输入值与获取到的数据进行比较
    proIdSearch(queryString, cb) {
      var restaurants = this.restaurants
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants
      cb(results)
    },
    createFilter(queryString) {
      return (state) => {
        return state.value.indexOf(queryString) === 0
      }
    },
    // // 3. 选中值后，需要做的处理
    proIdSelect(item) {
      this.forminput.experts = item.value
      this.forminput.experts_id = item.experts_id
      this.forminput.post_address = item.post_address
      this.forminput.post_telephone = item.post_telephone
    },
    getadd() {
      this.$refs.forminput2.validate((valid) => {
        if (valid) {
          let params = new URLSearchParams()
          params.append('experts_id', this.forminput.experts_id)
          params.append('experts', this.forminput.experts)
          params.append('product_name', this.forminput.product_name)
          params.append('guige', this.forminput.guige)
          params.append('fenshu', this.forminput.fenshu)
          params.append('post_name', this.forminput.post_name)
          params.append('post_telephone', this.forminput.post_telephone)
          params.append('post_address', this.forminput.post_address)
          params.append('colonel', this.forminput.colonel)
          params.append('express', this.forminput.express)
          Add(params)
            .then((res) => {
              if (res.code == 200) {
                this.show = true
                this.dialogFormVisible = false
                this.$message.success('添加成功')
                this.getAll()
              } else {
              }
            })
            .catch((err) => {
              if (err.request.status == 422) {
                this.dialogFormVisible = false
                this.$message.success('添加失败')
              }
            })
        }
      })
    },
    //  获取所有产品的接口
  },
}
</script>
<style lang="less" scoped>
.footer_btn {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}
/deep/ .el-dialog__body {
  height: 650px;
  // overflow-y: auto;
  color: #606266 !important ;
}
.lingyang {
  /deep/ .el-dialog__header {
    padding: 0;
  }
}
.table_img {
  width: 43px;
  height: 43px;
  margin: 20px 5px;
  border-radius: 50%;
}
.showimg {
  color: #266bd3;

  img {
    border-radius: 50%;
    border: 2px solid rgba(34, 51, 148, 0.712);
  }
}
.footer_btn {
  position: relative;
  bottom: 0;
}
.box {
  display: flex;
  padding: 10px;
  height: 600px;
  // width: 100%;

  .box_left {
    overflow-y: auto;
    height: 600px;
    // background-color: aqua;
    width: 220px;
    padding: 5px;
    border-right: 1px solid #dddd;
    margin-right: 10px;
    .box_left_daren2 {
      cursor: pointer;
      display: flex;
      color: #6666;
      align-items: center;
      span {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      img {
        width: 43px;
        height: 43px;
        margin: 20px 5px;
        border-radius: 50%;
      }
    }
    .box_left_daren {
      cursor: pointer;
      display: flex;
      align-items: center;
      span {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      img {
        width: 43px;
        height: 43px;
        margin: 20px 5px;
        border-radius: 50%;
      }
    }
  }
  .box_right {
    flex: 2;
    overflow-y: auto;
    height: 600px;
    .box_right_title_table {
      .box_right_title {
        display: flex;
        align-items: center;
        font-size: 18px;
        line-height: 50px;

        img {
          width: 16px;
          height: 16px;
          margin-right: 5px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/product/intelligent.vue